import * as FloatingBannerApi from '@bingads-webui-cc-react/floating-banner';
import { CcuiAlertCenter } from '@bingads-webui-clientcenter/alert-center';

import GlobalAppsModel from './global-apps-model';
import LoggingProxy from './logging-proxy';
import PerfProxy from './perf-proxy';
import type { GlobalAppsInitOptions, LoggingApi, PerformanceApi } from './types';

export type {
  GlobalAppsAlert,
  GlobalAppsAlertCenter,
  GlobalAppsAlertCenterI18n,
  GlobalAppsConfig,
  GlobalAppsFetchOptions,
  GlobalAppsI18n,
  GlobalAppsInitOptions,
  GlobalAppsInstrumentation,
  GlobalAppsNavigationHistory,
  GlobalAppsNavigationOptions,
  GlobalAppsPageContext,
  GlobalAppsStaticAlertCenter,
  LoggingApi,
  PagePermissions,
  PerformanceApi,
  PilotFlags,
} from './types';

export const globalApps = new GlobalAppsModel();

/**
 * Init function needs to be called before we use properties of GlobalAppsModel.
 * Now it's called in {@link https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppUI?path=%2Fprivate%2FUI%2FCommon%2FMicrosoft.Advertising.Web.Mvc%2FContent%2FScripts%2Fglobal-apps-init.js global-apps-init.js}
 * from {@link https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppUI?path=%2Fprivate%2FUI%2FCommon%2FMicrosoft.Advertising.Web.Mvc%2FExtensions%2FGlobalAppsExtensions.cs GlobalAppsExtensions}.
 * @param {object} pageContext - The pageContext that set by server-side.
 * @param {object} instrumentation - The instrumentation that contains logging tool and performance api.
 * @param {object} config - The component where we can get and set config.
 * @param {object} i18n - The i18n injected for alert center.
 * @return {void}
 */
export function init({
  pageContext,
  instrumentation,
  config,
  i18n,
}: GlobalAppsInitOptions) {
  globalApps.pageContext = pageContext;
  globalApps.loggingProxy = new LoggingProxy(instrumentation.logging as LoggingApi);
  globalApps.perfProxy = new PerfProxy(instrumentation.perfApi as PerformanceApi);
  globalApps.staticAlertCenter = new CcuiAlertCenter({ i18n });
  FloatingBannerApi.setConfig({ logInstrumentation: globalApps.loggingProxy });
  globalApps.alertCenter = FloatingBannerApi;
  globalApps.config = config;
  globalApps.setInitialized(true);
}
